module.exports = __webpack_public_path__ + "img/product-preview-22.7536662.png";